import React from "react";
import { Alert, AlertDescription, Box, Flex, Text } from "@chakra-ui/react";
import { FlexibleGrid } from "./FlexibleGrid";
import { AppliedFocus } from "./AppliedFocus";
import { EditingFocus } from "@/components/FocusLibraryDrawer/FocusPage";
import { StudentSortOrder, StudentSortOrderEnum } from "./StudentSortOrder";
import { envConfig } from "@/config";
import { ChakraFAIcon } from "@/components/ui/Icon";

interface Props {
	studentCount: number;

	isUpdatingFocus: boolean;

	setTabItemLimit: (limit: number) => void;
	appliedFocuses: EditingFocus[];
	endFocus: (focusId: string) => void;
	studentSortOrder: StudentSortOrderEnum;
	onSortOrderChange: (sortOrder: StudentSortOrderEnum) => void;
	classIsActive: boolean;

	bubbleUpdatedFocus: (focus: EditingFocus) => void;
}

export function FocusAndFlexibleGridBar(props: Props): JSX.Element {
	const maxStudents = envConfig.MAX_STUDENTS;

	return (
		<Flex justifyContent={"space-between"} alignItems={"center"} mx={"24px"} mt={"16px"} mb={"4px"}>
			{props.studentCount > maxStudents && (
				<Flex>
					<Alert status="warning" bgColor="#FFE8EA" mb="16px" pt="12px" width="unset">
						<Box mx="8px" pt="-4px">
							<ChakraFAIcon icon="fa-triangle-exclamation" variant="solid" color="#FF0000" />
						</Box>
						<AlertDescription fontSize="14px" fontWeight="500" pt="2px">
							Class cannot be started because there are {props.studentCount} students, exceeding the limit of {maxStudents}.
						</AlertDescription>
					</Alert>
				</Flex>
			)}

			<Flex alignItems={"center"} gap={3}>
				{props.appliedFocuses.map((focus) => (
					<AppliedFocus
						key={focus.id}
						focus={focus}
						isUpdatingFocus={props.isUpdatingFocus}
						endFocus={props.endFocus}
						classIsActive={props.classIsActive}
						bubbleUpdatedFocus={props.bubbleUpdatedFocus}
					/>
				))}
			</Flex>
			<Flex>
				{props.appliedFocuses.length > 0 && !props.classIsActive && (
					<Text>Focus is preset to start automatically when the class starts</Text>
				)}
			</Flex>
			<Flex alignItems={"center"} gap={3}>
				<StudentSortOrder onSortOrderChange={props.onSortOrderChange} studentSortOrder={props.studentSortOrder} />
				<FlexibleGrid setTabItemLimit={props.setTabItemLimit} />
			</Flex>
		</Flex>
	);
}
